import type { ServerPaginationConfig } from '@shared/types/module-config';

export const FG_MERCHANT_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const FG_MERCHANT_ROUTE_PATHS = {
  fullGatewayMerchant: '/movements/full-gateway-merchant',
};

export const FG_MERCHANT_API_PATHS = {
  depositsList: '/v1/api/platform/merchant/deposits/fullGateway',
  cashoutsList: '/v1/api/platform/merchant/cashouts/fullGateway',
  gatewayByPayin: '/v1/api/platform/gateway/payin',
  gatewayByPayout: '/v1/api/platform/gateway/payout',
  payinStatus: '/v1/api/platform/gateway/payin/status',
  cashoutStatus: '/v1/api/platform/withdrawals/cashouts/status',
  cashoutWithdrawalStatus: '/v1/api/platform/withdrawals/status',
  approvePayin: '/v1/api/platform/gateway/approve/fg-merchant',
  depositNotification: '/v1/api/platform/merchant/deposit',
  cashoutNotification: '/v1/api/platform/merchant/cashout',
};

export const DEPOSITS_URL_FILTER_KEYS = [
  'externalUserId',
  'merchantId',
  'depositExternalId',
  'depositId',
  'paymentId',
  'document',
  'merchantDepositId',
  'status',
  'createdFrom',
  'createdTo',
  'pageSize',
  'pageNumber',
];

export const CASHOUTS_URL_FILTER_KEYS = [
  'externalUserId',
  'merchantId',
  'cashoutExternalId',
  'cashoutId',
  'paymentId',
  'document',
  'merchantCashoutId',
  'status',
  'createdFrom',
  'createdTo',
  'pageSize',
  'pageNumber',
];